<template>
    <transition name="move">
    <div id="topics">
        <button class="topic" :disabled="topic1" @click="goPlan(true)">
            <img src="@/assets/svg/warning.svg" alt="Panneau danger">
            <span>Contre-indications</span>
        </button>
        <button class="topic">
            <img src="@/assets/svg/two-thin-arrows-forming-a-circle.svg" alt="Flèches formant un cercle">
            <span>Interactions</span>
        </button>
        <button class="topic">
            <img src="@/assets/svg/drugs.svg" alt="Pilules">
            <span>Utilisation concomitante d’autres médicaments <br> par voie orale</span>
        </button>
        <div id="topic-skip">
            <button @click="goPlan">
                Passer →
            </button>
        </div>

    </div>
    </transition>
</template>
<script>
    export default {
        name: 'Topics',
        data() {
            return {
                topic1: false,
                state : false
            }
        },
        methods: {
            goPlan(arg) {
                if (arg === true) {
                    this.$data.topic1 = true;
                    this.$emit('go')
                } else {
                    this.$emit('go2')
                }

            }
        }
    }
</script>
<style lang="scss">
    #topics {
        display: flex;
        flex-flow: column;
        position: fixed;
        justify-content: center;
        align-items: flex-start;
        overflow-y: auto;
        right: 0%;
        background-color: rgba(0, 0, 0, 0.50);
        width: 20%;
        height: 100%;
        top: 0;
        transition: 900ms;
        .topic {
            cursor: pointer;
            padding: 20px;
            text-align: center;
            width: 100%;
            box-sizing: border-box;
            transition: 0.5s cubic-bezier(.25, .8, .25, 1);
            background-color: transparent;
            border: none;
            outline: none;
            img {
                width: 100px;
                height: auto;
            }
            span {
                color: #fff;
                font-weight: normal;
                font-size: 1.5rem;
                display: block;
                margin-top: 10%;
            }
            &:hover {
                background-color: #2235a1;
            }
            &:disabled {
                opacity: 0.3;
                cursor: default;
                &:hover {
                    background-color: transparent;
                }
            }
        }
        #topic-skip {
            text-align: center;
            width: 100%;
            margin-top: 10%;
            button {
                border: 3px solid #fff;
                background-color: transparent;
                color: #fff;
                padding: 20px 40px;
                border-radius: 50px;
                min-width: 230px;
                font-size: 1.5rem;
                font-weight: bold;
                transition: 0.5s cubic-bezier(.25, .8, .25, 1);
                cursor: pointer;
                outline: none;
                overflow: hidden;
                position: relative;
                &:hover {
                    background-color: #2235a1;
                    border: 3px solid #2235a1;
                }
            }
        }
    }
</style>
